import { useState } from "react";
import { MapPin, Navigation } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const KEY = "avenue_gps_pref";
const APPS = {
  waze: { label: "Waze", url: (a) => `https://waze.com/ul?q=${encodeURIComponent(a)}&navigate=yes` },
  maps: { label: "Google Maps", url: (a) => `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(a)}` },
};

const openGps = (app, address) => { window.open(APPS[app].url(address), "_blank"); };

export const GpsAddress = ({ address, testid }) => {
  const [pref, setPref] = useState(() => localStorage.getItem(KEY));
  const [open, setOpen] = useState(false);
  const [always, setAlways] = useState(false);

  const onTap = () => { if (pref && APPS[pref]) openGps(pref, address); else { setAlways(false); setOpen(true); } };
  const choose = (app) => {
    if (always) { localStorage.setItem(KEY, app); setPref(app); }
    setOpen(false);
    openGps(app, address);
  };
  const reset = () => { localStorage.removeItem(KEY); setPref(null); };

  return (
    <div>
      <button type="button" data-testid={testid} onClick={onTap} className="flex items-start gap-2 text-left w-full group">
        <MapPin className="w-4 h-4 text-amber-400 mt-0.5 shrink-0" />
        <span className="text-sm text-slate-200 underline decoration-amber-500/40 underline-offset-4 group-hover:text-amber-200">{address}</span>
        <Navigation className="w-4 h-4 text-amber-400 shrink-0 ml-auto mt-0.5" />
      </button>
      {pref && APPS[pref] && (
        <p className="text-[10px] text-slate-500 pl-6 mt-0.5">GPS : {APPS[pref].label} · <button type="button" data-testid={`${testid}-gps-reset`} onClick={reset} className="text-amber-400 underline">changer</button></p>
      )}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="gps-dialog" className="bg-[#0F1320] border-amber-500/20 text-slate-100">
          <DialogHeader>
            <DialogTitle className="text-slate-100">Ouvrir le GPS</DialogTitle>
            <DialogDescription className="text-slate-400">{address}</DialogDescription>
          </DialogHeader>
          <div className="grid grid-cols-2 gap-3">
            {Object.entries(APPS).map(([k, a]) => (
              <Button key={k} data-testid={`gps-choose-${k}`} onClick={() => choose(k)} className="btn-gold rounded-xl py-6 text-base">{a.label}</Button>
            ))}
          </div>
          <label className="flex items-center gap-2 text-sm text-slate-300 mt-1 cursor-pointer">
            <Checkbox data-testid="gps-always-checkbox" checked={always} onCheckedChange={(v) => setAlways(!!v)} />
            Choisir toujours
          </label>
        </DialogContent>
      </Dialog>
    </div>
  );
};
